import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { TrackClickOptions } from '../../entities/tracking-options';
import type {
  SemContentRepository,
  TrackClickResult,
} from '../../repositories/sem-content-repository';

export type TrackClickUseCase = (
  options: TrackClickOptions,
) => Promise<TrackClickResult>;

export const trackClickFactory =
  (provider: Pick<SemContentRepository, 'trackClick'>): TrackClickUseCase =>
  async (options) => {
    const parsedOptions = TrackClickOptions.safeParse(options);

    if (!parsedOptions.success) {
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToTrackClick',
            rootCause: parsedOptions.error,
          },
        ],
      });
    }

    return provider.trackClick(options);
  };
